module.exports = __webpack_public_path__ + "4a38d1b39c97ef45ffcc2e90703bff02.png";